"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _SSRProvider = _interopRequireDefault(require("./SSRProvider"));
var _default = _SSRProvider.default;
exports.default = _default;